import React, { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalContext, Flex, Text, Checkbox, toast } from 'dash-ui';
import { useDeleteMediaFolderByIdMutation } from 'gql/generated.graphql';

function RemoveFolderModal() {
  const { t: tCommonLabels } = useTranslation('common', {
    keyPrefix: 'labels',
  });
  const { t: tPages } = useTranslation('pages', {
    keyPrefix: 'propertyPage',
  });
  const { t: errorSlugs } = useTranslation('common', {
    keyPrefix: 'serverMessages',
  });
  const [isChecked, setIsChecked] = useState(false);
  const { isOpenCurrent, payload, toggleModal, setPayload } =
    useContext(ModalContext);
  const isOpen = !!isOpenCurrent['RemoveFolderModal'];

  // @ts-ignore
  const { media, onConfirm = () => {} } = payload || {};
  const folderId = media?._id;
  const [deleteMediaFolderByIdMutation, { loading }] =
    useDeleteMediaFolderByIdMutation({
      update(cache) {
        const normalizedId = cache.identify({
          id: folderId,
          __typename: 'Media',
        });
        cache.evict({ id: normalizedId });
        cache.gc();
      },
    });

  const onModalClose = () => {
    toggleModal(false, 'RemoveFolderModal');
    setPayload(null);
    onConfirm();
  };

  const onSubmit = () => {
    if (folderId) {
      return deleteMediaFolderByIdMutation({
        variables: {
          mediaId: folderId,
          withContent: isChecked,
        },
      })
        .then(() => {
          toast.success(
            tPages('folderDeletedMessage', {
              folderName: media?.folderName ?? '',
            })
          );
          onModalClose();
        })
        .catch((error) => {
          toast.error(errorSlugs(error.message) || errorSlugs`unknown` || '');
          onModalClose();
        });
    }
  };

  return (
    <Modal
      title={tPages`removeFolderModalLabel` || ''}
      isOpen={isOpen}
      onRequestClose={onModalClose}
      submitButton={{
        title: tCommonLabels`confirm`,
        isLoading: loading,
        disabled: loading,
        onClick: onSubmit,
      }}
      cancelButton={{ title: tCommonLabels`cancel`, onClick: onModalClose }}
    >
      <Flex flexDirection="column">
        <Flex my={6}>
          <Text>
            {tPages('removeFolderModalBodyLabel', {
              folderName: media?.folderName ?? '',
            })}
          </Text>
        </Flex>
        <Flex mb={6}>
          <Checkbox
            label={tPages`removeFolderModalCheckboxLabel` || ''}
            onChange={(value) => setIsChecked(value)}
          />
        </Flex>
      </Flex>
    </Modal>
  );
}

export default RemoveFolderModal;
